const sha1 = require("crypto-js/sha1");
const exception = require('../exception/index.js');
const {is_callable} = require("/../common_lib/util.js");

module.exports.delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}



module.exports.hash_string = (source_string) =>{
    let result = sha1(source_string);
    return result;
}


module.exports.device_is_smartphone = () => {
    if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
        return true;
    } else {
        return false;
    }
}



module.exports.set_DOM_element = (selector,key,value) => {

    Array.from(document.querySelectorAll(selector)).forEach(
        (DOM_element) =>{
            DOM_element[key]=value;
        }
    );

}

module.exports.compose_event_handler_initializer = (selector,handler,event_name = 'click',debug=false) => {
    return (option={})=>{
        if(debug) debugger;
        let ary_DOM_element = document.querySelectorAll(selector);

        for(const DOM_element of ary_DOM_element){
            DOM_element.addEventListener(event_name,handler);
        }

    }
}
//////////////////////////////////////////////////////////
// 判定関数

module.exports.is_string = (x) => {
    return Object.prototype.toString.call(x) === "[object String]"
}

//////////////////////////////////////////////////////////
// テキスト変更用関数

module.exports.set_element_text = (selector=null,text,option={})=>{

    let ary_DOM_element = Array.from(document.querySelectorAll(selector));
    let text_setter=(DOM_element)=>{return ""};

    let put_log;

    if('slient' in option && option['slient']){
        put_log = function(){};
    } else {
        put_log = console.log;
    }

    if(ary_DOM_element.length == 0){
        put_log(`set_element_text:[warning]target not found(selector: ${selector})`);
        return;
    }
    if(selector == null){
        put_log(`set_element_text:[warning]no selector`);
        return;
    }

    /*
        [element\.insertAdjacentHTML \- Web API \| MDN](https://developer.mozilla.org/ja/docs/Web/API/Element/insertAdjacentHTML)    
    */
    if((typeof text === "string" || text instanceof String)){
        for(DOM_element of ary_DOM_element){
            DOM_element.innerHTML = text;
        }
    

    } else if((text && typeof text === 'function')){
        /*
        下のようなシグネチャの関数を与えること。
        (DOM_element,option) => {
            return new_text; // 新しいテキストを返す。
        }
        */
        for(DOM_element of ary_DOM_element){
            DOM_element.innerHTML = text(DOM_element,option);
        }
    };
}

// FIXME:promise版も実装しないといけないかもしれない。
module.exports.DOM_foreach = (selector,manip)=>{

    DOM_ary_target=Array.from(document.querySelectorAll(selector));
    DOM_ary_target.forEach(manip);

}

/**
 * fetch()の第一引数に与えるオプション連想配列を生成する
 * 生成は、関数内のデフォルト値と引数で与えられる連想配列をマージして行う
 * 
 * @param {Ojbect} fetch_option fetch()に与えるオプション
 * @returns {Ojbect} fetch()に与えるオプション
 */
const compose_fetch_option = (fetch_option={}) => {
    let _fetch_option = {
        method: 'POST',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        mode: 'cors',
        credentials: 'include' // クッキーの送信
    };
    
    _fetch_option = {..._fetch_option , ...fetch_option};

    return _fetch_option;
};

const compose_ajax_sub_simple_request = (option={}) => {
    let {fetch_option,url} = option;

    //ハンドラ
    let {form_data_acquire,closing} = option;

    /*
        ファサード関数でチェック済みなのでここではチェックなし
    */
    let _fetch_option = compose_fetch_option(fetch_option);
    
    return ()=>{
        let routine = Promise.resolve();
        if(url){
            routine = routine.then(
                ()=>{
                    _fetch_option.body = form_data_acquire.call(null);
                    return fetch(url, _fetch_option);
                }
            );
            routine = routine.then(
                (response)=>{
                    return response.json();
                }
            );
        }
        routine = routine.then(
            (json)=>{
                closing.call(null,json);
            }
        );
        routine = routine.catch(
            (err)=>{
                throw err;
            }
        );

        return routine;
    }
    
}

const compose_ajax_sub_operate_query = (option={}) => {

    let {fetch_option,verify_url,operation_url} = option;

    //ハンドラ
    let {form_data_verify,form_data_operation,closing} = option;

    /*
        ファサード関数でチェック済みなのでここではチェックなし
    */
    
    let _fetch_option = compose_fetch_option(fetch_option);

    return ()=>{
        let routine = Promise.resolve();
        if(verify_url){
            routine = routine.then(
                ()=>{
                    _fetch_option.body = form_data_verify.call(null);
                    return fetch(verify_url, _fetch_option);
                }
            );
            routine = routine.then(
                (response)=>{
                    return response.json();
                }
            );
        }
        if(operation_url){
            routine = routine.then(
                (json)=>{
                    _fetch_option.body = form_data_operation.call(null,json,_fetch_option.body);
                    return fetch(operation_url, _fetch_option);
                }
            );
            routine = routine.then(
                (response)=>{
                    return response.json();
                }
            );
        }
        routine = routine.then(
            (json)=>{
                closing.call(null,json);
            }
        );
        routine = routine.catch(
            (err)=>{
                throw err;
            }
        );

        return routine;
    }

}

module.exports.compose_ajax = (option={}) => {

    //ハンドラ
    let {form_data_verify,form_data_acquire,form_data_operation,closing} = option;

    let mode="";
    
    if(is_callable(form_data_acquire)) mode = "simple_request";
    if(is_callable(form_data_verify)) mode = "operate_query";

    if(closing){
        if(is_callable(closing) === false){
            throw Error(`compose_ajax : field 'closing' must be callable object`);
        }
    }

    switch(mode){
        case "operate_query":
                if(is_callable(form_data_verify) === false){
                    throw Error(`compose_ajax : field 'form_data_verify' must be callable object`);
                }
                if(form_data_operation){
                    if(is_callable(form_data_operation) === false){
                        throw Error(`compose_ajax : field 'form_data_operation' must be callable object`);
                    }
                }
                return compose_ajax_sub_operate_query(option);
        case "simple_request":
            if(is_callable(form_data_acquire) === false){
                throw Error(`compose_ajax : field 'form_data_acquire' must be callable object`);
            }
            return compose_ajax_sub_simple_request(option);
        default:
            throw Error(`compose_ajax : field 'form_data_verify' or 'form_data_acquire' must be callable object`);            
    }


}
